import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AccordionService} from "./accordion.service";
import {ScrollTriggerService} from "../../services/scroll-trigger.service";

@Component({
  selector: 'brt-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements OnInit, OnDestroy {
  @Input("id") id = -1;
  @Input('idx') idx = -1;
  @Input("title") title = "";
  @Input("state") isOpened = false;

  @ViewChild("contentWrapperEl") contentWrapperEl = new ElementRef(null);
  @ViewChild("contentEl") contentEl = new ElementRef(null);

  constructor(private accordionService: AccordionService, private stService: ScrollTriggerService) {
  }

  ngOnInit() {
    this.accordionService.addAccordion(this);
  }

  ngOnDestroy() {
    // console.log("Accordion was destroyed");
    this.accordionService.removeAccordion(this);

  }

  toggleState(forceSiblings = false) {
    if(this.contentWrapperEl.nativeElement && this.contentEl.nativeElement) {
      this.isOpened = !this.isOpened;

      const contentWrapperHtmlEl = this.contentWrapperEl.nativeElement as HTMLElement
      const contentHtmlEl = this.contentEl.nativeElement as HTMLElement;
      let height = 0;
      if(this.isOpened) {
        height = contentHtmlEl.clientHeight;

        if(forceSiblings) {
          this.accordionService.closeSiblings(this);
        }

      }

      // console.log(contentHtmlEl.clientHeight);

      contentWrapperHtmlEl.style.height = height + "px";
      setTimeout(() => {
        this.stService.updateTriggers();
      }, 600);
    }
  }
}
